// extracted by mini-css-extract-plugin
export default {"form":"PurchaseInfo_form__GpB6x","sectionInfo":"PurchaseInfo_sectionInfo__zKfdP"};